import BpkTickIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/tick';
import { BpkButtonLink } from '@skyscanner/backpack-web/bpk-component-link';
import BpkRadio from '@skyscanner/backpack-web/bpk-component-radio';
import BpkText, {
  TEXT_COLORS,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { FilterType } from '@shared/types/frontend/ubff/hotel-reviews';

import STYLES from './FilterSortOption.module.scss';

import { alignIconTextSm } from '@shared/ui/common/Alignment';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';

const cls = cssModules(STYLES);
const AlignedTick = alignIconTextSm(BpkTickIcon);

type props = {
  onOptionChanged: () => void;
  value: string;
  displayText: string;
  checked: boolean;
  filterType: FilterType | string;
};

const FilterSortOption = ({
  checked,
  displayText,
  filterType,
  onOptionChanged,
  value,
}: props) => {
  const contentNode = (
    <BpkText
      className={cls('FilterSortOption__text')}
      color={TEXT_COLORS.textPrimary}
    >
      {displayText}
    </BpkText>
  );

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) =>
        isMobile ? (
          <BpkButtonLink
            onClick={onOptionChanged}
            role="radio"
            className={cls('FilterSortOption__button')}
            aria-checked={checked}
            implicit
          >
            {contentNode}
            {checked && (
              <AlignedTick className={cls('FilterSortOption__icon')} />
            )}
          </BpkButtonLink>
        ) : (
          <button
            key={value}
            type="button"
            className={cls('FilterSortOption__option')}
            onClick={onOptionChanged}
            aria-label={displayText}
            role="radio"
            aria-checked={checked}
          >
            <div className={cls('FilterSortOption__radio')}>
              <BpkRadio
                name={filterType}
                label={
                  <BpkText
                    className={cls('FilterSortOption__text')}
                    color={TEXT_COLORS.textPrimary}
                  >
                    {displayText}
                  </BpkText>
                }
                checked={checked}
                aria-label={displayText}
                tabIndex={-1}
                aria-hidden="true"
                className={cls('FilterSortOption__radio--disabled')}
              />
            </div>
          </button>
        )
      }
    </BpkBreakpoint>
  );
};

export default FilterSortOption;
